import { render, staticRenderFns } from "./add_classify_tag_form.vue?vue&type=template&id=c29c44a2"
import script from "./add_classify_tag_form.vue?vue&type=script&lang=js"
export * from "./add_classify_tag_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports